import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import { SettingsService } from "@/api";

/**
 * Default error handler to display error messages using react-toastify.
 * @param {object} err - The error object from the query.
 */
const onDefaultError = (err) => {
  if (err.response?.data?.message) {
    toast.error(err.response.data.message);
  }
};

/**
 * Custom hook for fetching site configuration settings.
 * It utilizes the `useQuery` hook to retrieve settings data.
 *
 * @param {function} onSuccess - Callback to execute when the query is successful.
 * @param {function} [onError=onDefaultError] - Callback to execute when the query fails.
 *
 * @returns {object} Query object from `useQuery`.
 */
const useGetSettingData = (onSuccess, onError = onDefaultError) => {
  return useQuery({
    queryKey: ["settings-data"], // Query key
    queryFn: () => SettingsService.getConfiguration(), // Query function
    onSuccess, // Success callback
    onError, // Error callback
    retry: false,
  });
};

export { useGetSettingData };
